import { useAppContext } from "app/AppContext";
import firebaseUtil from "firebaseUtil";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserUid } from "useAuth";

import Home from "./Home";
import RoutesMenusFazenda from "./Fazenda";
import RoutesMenusNascimento from "./Nascimento";
import RoutesMenusPerfil from "./Perfil";
// import RoutesMenusMatriz from "./Matriz";


export default function RoutesMenusPrivate() {
    const navigate = useNavigate();

    const isAuthenticated = useUserUid();
    const { addMenu, addRoute, removeMenusRoutes } = useAppContext();

    useEffect(() => {
        if (isAuthenticated) {
            addMenu({
                uid: "Inicio",
                text: "Início",
                iconName: "Home",
                sequence: "0",
                action: () => {
                    navigate("/");
                },
            });
            addRoute({ uid: "homeauth", title: "Início", route: "/", element: <Home /> });
            addMenu({
                uid: "sair",
                text: "Sair",
                iconName: "ExitToApp",
                sequence: "999999",
                action: () => {
                    firebaseUtil.logout();
                    navigate("/login");
                },
            });
        }
        return () => {
            console.log("remove buttoms private");
            removeMenusRoutes(["Inicio", "homeauth", "sair"]);
        };
    }, [addMenu, addRoute, isAuthenticated, navigate, removeMenusRoutes]);

    if (!isAuthenticated) {
        return "";
    }

    return (
        <>
           <RoutesMenusFazenda/>
           <RoutesMenusNascimento/>
           {/*<RoutesMenusMatriz/>*/}
           <RoutesMenusPerfil/>
        </>
    );
}
